import React from 'react';
import { HandoffSnapshot } from '../../../handoff-hub.types';
import { HandoffChecklistV2 } from '../edit-handoff/handoff-checklist-v2/handoff-checklist-v2';
import { mapSnapshotMetricsToMessagingAirChecklist } from '../edit-handoff/messaging-air-handoff/messaging-air-handoff.helpers';

type Props = {
  snapshotData: HandoffSnapshot;
  locationId: string;
};

export const MessagingAirSnapshotView = ({ snapshotData, locationId }: Props) => {
  const mappedMetrics = mapSnapshotMetricsToMessagingAirChecklist(
    snapshotData.metrics,
    locationId
  );

  return (
    <HandoffChecklistV2
      metrics={mappedMetrics}
      notes={snapshotData.officeExperience || ''}
      readOnly
    />
  );
};
